import { jsx, jsxs } from 'react/jsx-runtime';
import clsx from 'clsx';
import { Paragraph } from '../paragraph/paragraph.js';
import '../../icons/icon.js';
import AlertCircle from '../../icons/informative/alert-circle.js';
import CheckCircle from '../../icons/informative/check-circle.js';
import { TOKENS, alertStyles, paragraphStyles, messageStyles, checkCircleStyles } from './input-message.css.js';
import { TOKENS as TOKENS$1 } from '../../icons/icon.css.js';
import { TOKENS as TOKENS$2 } from '../paragraph/paragraph.css.js';

function BaseMessage({ children, className, icon, variant, ...rest }) {
  return /* @__PURE__ */ jsxs("div", { className: clsx(messageStyles, className), ...rest, children: [
    icon,
    /* @__PURE__ */ jsx(Paragraph, { className: paragraphStyles({ variant }), variant: TOKENS$2.variant.secondary, children })
  ] });
}
function SuccessMessage({ children, ...rest }) {
  return /* @__PURE__ */ jsx(
    BaseMessage,
    {
      icon: /* @__PURE__ */ jsx(CheckCircle, { size: TOKENS$1.size.sm, className: checkCircleStyles, color: TOKENS$1.color["green-50"] }),
      variant: TOKENS.variant.success,
      ...rest,
      children
    }
  );
}
function ErrorMessage({ children, ...rest }) {
  return /* @__PURE__ */ jsx(
    BaseMessage,
    {
      icon: /* @__PURE__ */ jsx(AlertCircle, { size: TOKENS$1.size.sm, className: alertStyles, color: TOKENS$1.color["red-50"] }),
      variant: TOKENS.variant.error,
      ...rest,
      children
    }
  );
}

export { BaseMessage, ErrorMessage, SuccessMessage, TOKENS as tokens };
